import React from "react";
import { Link } from "react-router-dom";
import { FaProjectDiagram } from "react-icons/fa";
import { ImSpinner9 } from "react-icons/im";
import { TopProjectList } from "../../constants";

const Projects = ({ theme }) => {
  return (
    <div
      className={`${
        theme === "dark" ? "border-darkLineColor" : "border-lightLineColor"
      } pt-20 pb-10 border-b-[1px]`}
    >
      <div className="flex flex-row justify-between items-center">
        <h3
          className={`${
            theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
          } text-[32px] flex flex-row justify-center lgl:justify-start items-center gap-4 text-center lgl:text-left font-bold`}
        >
          Projects
          <span>
            <FaProjectDiagram className="text-iconColor" />
          </span>
        </h3>
        <Link to="/projects">
          <p
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightTextDesignColor"
            } text-xl flex justify-between items-center gap-2 px-5 rounded-md py-2 border-[1px] cursor-pointer group`}
          >
            See All
            <span>
              <ImSpinner9
                className={`animate-spin ml-1 transition-translate duration-300 group-hover:animate-none ${
                  theme === "dark"
                    ? "text-iconColor"
                    : "text-lightTextDesignColor"
                }`}
              />
            </span>
          </p>
        </Link>
      </div>
      <div className="py-10 flex flex-col gap-8">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 px-6">
          {TopProjectList.map((project) => (
            <div
              key={project.id}
              className={`${
                theme === "dark"
                  ? "border-darkLineColor bg-darkLineColor"
                  : "border-lightTextDesignColor bg-lightTextDesignColor"
              } w-full h-80 rounded-lg overflow-hidden group relative border-2`}
            >
              <a href={project.link} target="_blank" rel="noreferrer">
                <img
                  className="w-full h-[1200px] translate-y-0  group-hover:-translate-y-[77.5%] transition-all hover:ease-in duration-[4s] cursor-pointer object-cover"
                  src={project.image}
                  alt={project.title}
                />
                <p
                  className={`${
                    theme === "dark"
                      ? "bg-darkLineColor text-darkTextColor"
                      : "bg-lightTextDesignColor text-white"
                  } absolute  hover:bg-opacity-100 text-lg font-semibold bottom-0 text-center w-full p-2 bg-opacity-70 hidden group-hover:inline-block duration-300 opacity-80 hover:opacity-100`}
                >
                  {project.title}
                </p>
              </a>
            </div>
          ))}
        </div>
        <a href={"https://reactbd.com/"} target="_blank" rel="noreferrer">
          <div
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor hover:bg-black"
                : "text-lightTextColor border-gray-500 hover:bg-white"
            } text-xl flex flex-row justify-center text-center items-center gap-4 font-bold mt-6 border-[1px] py-3 transition-hover duration-300 relative group overflow-hidden`}
          >
            <p className="uppercase tracking-wider">Purchage my Services</p>
            <span className="absolute w-full h-[1px] bg-blue-800 left-0 top-0 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-500"></span>
            <span className="absolute w-full h-[1px] bg-blue-800 left-0 bottom-0 translate-x-[100%] group-hover:translate-x-0 transition-transform duration-500"></span>
            <span className="absolute w-[1px] h-full bg-blue-800 left-0 bottom-0 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-500"></span>
            <span className="absolute w-[1px] h-full bg-blue-800 right-0 bottom-0 -translate-y-[100%] group-hover:translate-y-0 transition-transform duration-500"></span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Projects;
